import { useMemo } from "react";
import { useSelector } from "react-redux";

import { InternalApi } from "../config/internalApi";
import { useSite } from "../hooks/site";

export const useInternalApi = () => {
	const { backendApiUrl } = useSite();
	const auth = useSelector((state) => state.auth);
	const jwtToken = auth.user?.jwtToken;
	const pltToken = auth.user?.pltToken;

	const internalApi = useMemo(
		() => new InternalApi(backendApiUrl, jwtToken, pltToken),
		[backendApiUrl, jwtToken, pltToken],
	);

	return internalApi;
};
